import React from "react";
import { ArrowButton } from "../../components/arrow-button";

interface HidayetGunesiProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}

const HathorZemzem = (props: HidayetGunesiProps) => {
    return (
        <div style={{ display: props.isVisible ? "block" : "none" }}>
            <article>
                <ArrowButton onClick={props.comeBackSemaSection} />
                <h4 className="section-title">
                    HATHOR <br /> ZEMZEM <br />
                    (Harvard Üniversitesi Profesörü<br />
                    ve Afrika-Kafkas-Ortadoğu Dilleri Bölüm Başkanı)
                </h4>

                <p className="text-bold">
                    Zemzem’in İslam’ı seçiş öyküsünü kendinden
                    dinleyelim:
                </p>

                <p>
                    Çek Cumhuriyeti’nde Hıristiyan bir annenin ve Budist bir babanın kızı olarak dünyaya geldim. Beni çocukken Amerika’daki New Jersey eyaletinde yaşayan Hıristiyan bir aileye evlatlık olarak vermişler. Onlar da beni Hıristiyan okullarında Hıristiyanlık inancı üzerine yetiştirdiler.
                </p>

                <p>
                    12 yaşımdan sonra dinlere olan ilgim ve saygım artmaya başladı. 18 yaşımdan sonra hür irademle bütün dinler üzerine (Budizm, Hinduizm, Yahudîlik, Hıristiyanlık ve İslam) çalışmalarım oldu. Amerikan Harvard Üniversitesi tarihinde 32 yaşında iken profesörlük unvanı alan sayılı kişilerden oldum. 34 lisan bilmekle beraber 18 dili ana dilim gibi akıcı olarak konuşabilirim. Çeşitli ülkelere seyahat edip din büyüklerinin konferanslarına katıldım, sohbetlerini dinledim. Dinler üzerine muhtelif kitaplar okudum. Çin, Hindistan, Japonya, Avrupa ve Amerika’da ciddi akademik araştırmalarım oldu.
                </p>

                <p>
                    Amerika’da Cerrahî Sufilerin zikirlerini izleme ve sohbetlerini dinleme fırsatına sahip oldum. Bunun neticesinde İslam dinine olan aşkım ve şevkim son derece arttı. Çok mutlu oldum. İslam’ın nurlu yolunun kapısının bana açıldığını hissettim.
                </p>

                <p>
                    <span className="text-bold">Hz. Mevlana’nın: “Gel, gel… Ne olursan ol yine gel. Yüz bin defa tövbeni bozmuş olsan da yine gel… Bizim dergâhımız ümitsizlik dergâhı değildir.”</span>çağrısının bana ulaşmasıyla gönlüme hidayet güneşinin doğduğunu hissettim. Ve İstanbul’a doğru bir seyahat gerçekleştirdim. 10 gün süren bu seyahatim esnasında Fatih Camii’si civarında bulunan Cerrahi Zaviyesinde Yakub Baba ile tanıştım. Orada Sufîlerle görüştüm. İlahi aşk, iman ve İslam üzerine tasavvuf sohbetlerine
                    katıldım. Mevlevî semazenlerinin giyim kuşam, namaz, oruç, secde, zikir, sohbet ve sema gibi diğer dinlerde hiç rastlanmayan güzellikleri, tasavvufu yaşayan sufilerin yaşamlarında gördüm. Bu güzelliklerden müthiş etkilendim. Ve burada hayatımın en güzel günlerini yaşadığımı hissettim. Bir ara orada vecde gelip Allah diyerek öyle bir sayha attım ki Ali Yakub Baba’ya dönerek: “Bundan sonra benim gerçek manevi Harvard’ım burası”, dedim.
                </p>

                <p>
                    <span className="text-bold">“Amentü billahi ve melâiketihi,ve kütübihî ve rusülihî ve’l yevmi’l-âhıri ve bi’l-kaderi, hayrihî ve şerrihi mina’llâhi teâlâ ve’l-ba’sü ba’de’l mevt. Hakkun, Eşhedü en lâ ilâhe illallâh ve eşhedü enne Muhammeden abdühû ve rasûlühü.”</span> deyip kelime-i şehadet getirerek İslam’la müşerref oldum.
                </p>

                <p className="text-bold">
                    İslam'ın esasları olan Kelime-i Şehâdet, Namaz, Oruç, Zekât ve Hac bana talim buyruldu.
                </p>

                <p>
                    Bana istediğim bir İslamî isim seçebileceğim söylendi. Ben de zemzem suyunun dünyaca çok kutsal ve saygın olması hasebiyle “Zemzem” ismini almak istedim.  Yakub Baba da bu isteğim üzerine: “İnşallah ‘Zemzem’ ismi sana ağır gelmez” duasıyla İslamî isim olarak Zemzem adını bana verdi.
                </p>

                <p>
                    Ali Yakub Baba’nın tavsiyesi ile Zaviye’de sema derslerine başladım. 5 gün içerisinde sema çıkarmak nasip oldu. Bu durum üzerine Ali Yakub Baba: “Beş günde sema çıkarmak görülmüş bir şey değildir. Bu bir keramettir. Hz. Pir’in himmeti ile Allah size ikram etti. Harvard Üniversitesinde artık Hz. Pir Mevlânâ Nureddin Cerrahî Hazretlerinin himmeti ile güzel bir cemaatimiz oldu.” dedi.
                </p>

                <p>
                    Üç sene sonra anne ve babam Amerika’dan sema meşkimi izlemek için geldiler. Sema meşkini izledikten sonra Ali Yakub Baba’ya:  “Kızımızın böyle manevi bir dereceye ulaştığını görmek bizi çok mutlu etti.” dediler.
                    Ayrıca Amerika New Jersey’de bulunan çiftliğimizi dergâha dönüştürmem için bana tahsis etmek istediklerini de eklediler. Fakat bunu gerçekleştirmem için uygun şartlar oluşmadı.
                </p>

                <p>
                    Günün birinde bir spor salonunun önünden geçerken orada spor yapan insanlar dikkatimi çekti. Ve gidip onlara “Mistik Danslar topluluğuna” katılmaları için teklifte bulundum. Orada bulunan 19 kişi teklifimi kabul edince onları evime davet ettim. Ve sema çalışmalarına başladık. Sema derslerine başladıktan kısa bir süre sonra 19 kişinin 9’u İslam ile müşerref oldu. Bunun hakkında Ali Yakub Baba’ya 7 sayfalık bir mektup gönderdim.
                </p>

                <p>
                    Ayrıca İstanbul’da bulunduğum süre zarfında İtalyan İbrahim Şahidi ve Kanadalı Semine Hanımın da kısa zamanda sema çıkarmasına yardımcı oldum.
                </p>

                <p>
                    Bir gün Harvard Üniversitesinin konferans salonunda Sema gösterisi yapıyordum. Sema gösterisini izleyen öğrenci ve hocalar ilk bakışta ne yaptığıma anlam veremediler. Dikkatlice izlediklerinde Sufi dansı yaptığımı fark ettiler. Semayı bitirince tıpkı bir Mevlevi gibi sağ ve sola niyaz ederek selamladım. Oradaki izleyiciler beni tebrik ettiler. Ve bana bu dansı nereden öğrendiğimi sordular. Ben de İstanbul’da bulunan Mistik Danslar Topluluğunda öğrendiğimi belirttim. Sema gösterisinin üzerinden henüz birkaç gün geçmişti ki öğretim görevlisi arkadaşlarımın bana yaklaşımlarının gözle görülür biçimde değiştiğini fark ettim. Bana karşı olan samimiyetlerinin daha da arttığını hissettim.
                </p>

                <p>
                    Bir süre sonra Rektörlük tarafından <span className="text-bold">Afrika-Kafkas-Ortadoğu Dilleri</span> Bölüm Başkanlığına getirildim. Bu görevin bana verilmesiyle birlikte “Maneviyatın bu kadar güçlü olduğunu” ilk defa hissettim. Çünkü benden akademik kariyeri daha ileride olan Profesörler vardı. Ancak bize nasip oldu. Duanın gücüne olan inancım arttı, Elhamdülillah!
                </p>

                <p>
                    İslam tasavvufuyla buluşmam beni çok mutlu etti. O kadar lâtif, o kadar nazik ve derin ki kelimelerle ifade edilemez! Tasavvuf ilmi ancak yaşanılarak anlaşılabilir.
                </p>

                <p>
                    Fırsat buldukça Amerika’dan <span className="text-bold">İstanbul’a</span> tasavvuf ilminin yaşatıldığı sufî meclislerini ziyaret ederdim. Allah bana bir hafta içinde sema çıkarmayı lütfetti. İslam’ın nurlu yoluna hizmet etme gayretindeyim. Ve eski dindaşlarımın da bu nurlu yolda hidayet bulmasını Allah’tan niyaz ederim.
                </p>

                <p>
                    Zemzem Hanım’ın yüzlerce mektubundan birkaç tanesini buraya bırakıyoruz.
                </p>

                <div className="text-italic">
                    <p>
                        Es-Selam-u Aleyküm ya Kemal!
                    </p>

                    <p>
                        Elhamdülillah, geçen gece (Miraç gecesi) Baba ile alakalı bir mana gördüm. Çok basitti. “Ben Sema ediyordum ve başparmağıma baktığım zaman, Baba’nın bana bakan yüzünü gördüm ve ilk defa olarak, gönlümden (sadece aklımdan değil) Sema’nın Şeyh ile bağlantısı ve semazenin Sema’da Şeyhi kanalıyla ve onun yönlendirmesiyle nasıl öldüğünü gerçekten anladım. Başparmağıma bakmayı asla unutmayacaktım. Çünkü başparmağımın tırnağı Baba’nın yansımasını içinde barındırıyordu! Baba her saniye ve her adımda tam orada beni yönlendirmek için beklerken neden başka bir yere bakacaktım ki!”
                    </p>
                    <p>
                        Lütfen mümkün olduğunda bu rüyayı Baba’ya ilet İnşallah.
                    </p>

                    <p>
                        Ayrıca lütfen Ona çalışmak için bir Sema tahtası yapmama izin verir mi diye sor. Ve eğer izin verirse, tam olarak nasıl yapmalıyım, hangi ağaçtan ve hangi ebatlarda olmalı, Baba’ya sorabilir misin? Yahudi ve Hristiyan talebeleri sema öğrenmek istiyorlar. Yaklaşık 19 kişiler daha sonra Müslüman olabilirler. Baba’nın bu konu hakkında düşüncesi nedir bana bilgi verebilir misin?
                    </p>

                    <p>
                        Her zamanki gibi teşekkür ederim Kemal!
                    </p>

                    <p>
                        İyi olduğunu ümid ederim ve Aralık’ta geldiğimde tekrardan görüşmek üzere inşallah.
                    </p>
                    <p>
                        Es-Selam-u Aleyküm ya Kemal!
                    </p>

                    <p>
                        Selamlar ve barış! Bu kutsal Miraç gecesinde hepinizi düşünüyorum. Hepimizin gönülleri birlikte yükseltilsin!
                    </p>

                    <p>
                        Hepimiz aşkı cisimleştirme mücadelemizin içinde yükselelim ve Cennet şerbetlerini beraberce tadalım inşallah. Lütfen Baba’ya benim ölümsüz adanmışlığımı ve Resulullah (S.A.V) ‘in kutsal yükselişi gibi dünyadan Cennetlere yayılan aşka olan ümidimi ilet. İnşallah ney çalışmaya yeniden başlamaya zorlanmış hissediyorum. Lütfen Baba‘ya benim yerime bu konuda ne düşündüğünü sor. Mükemmel ve nazik bir ulak olduğun için teşekkür ederim.
                    </p>

                    <p>
                        Ya Hu! Selamun Aleyküm.
                    </p>
                </div>
            </article>
        </div>
    );
}

export default HathorZemzem;